/**
 * Classifica o erro cru devolvido pela UAZAPI num envio de WhatsApp.
 *
 * O payload é analisado por regex (e não por `JSON.parse`) porque o detalhe é
 * gravado truncado em `platform_whatsapp_send_log.error_detail`.
 */

export type WhatsappSendFailure =
    | { kind: 'restricted'; until: string | null }
    | { kind: 'disconnected' }
    | { kind: 'unknown'; detail: string | null };

const TIMELOCK_ACTIVE = /"reachout_timelock"\s*:\s*\{[^}]*"active"\s*:\s*true/i;
const TIMELOCK_UNTIL = /"reachout_timelock"\s*:\s*\{[^}]*"until"\s*:\s*"([^"]+)"/i;
const TEMPORARY_RESTRICTION = /server error 463|temporary restr/i;
const DISCONNECTED = /disconnect|not reconnectable/i;

function extractMessage(raw: string): string {
    const match = raw.match(/"(?:message|error)"\s*:\s*"((?:[^"\\]|\\.)*)"/);
    if (!match) return raw;
    return match[1].replace(/\\"/g, '"').replace(/\\n/g, ' ').trim() || raw;
}

export function classifyWhatsappSendError(raw: string | null | undefined): WhatsappSendFailure {
    const text = (raw ?? '').trim();
    if (!text) return { kind: 'unknown', detail: null };

    if (TIMELOCK_ACTIVE.test(text)) {
        return { kind: 'restricted', until: text.match(TIMELOCK_UNTIL)?.[1] ?? null };
    }
    if (TEMPORARY_RESTRICTION.test(text)) {
        return { kind: 'restricted', until: null };
    }
    if (DISCONNECTED.test(text)) {
        return { kind: 'disconnected' };
    }
    return { kind: 'unknown', detail: extractMessage(text) };
}
